import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output, SimpleChanges,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { IGetBookingsCommonResponse } from "libraries/service/resources/booking/interfaces/IGetBookings";
import {
    IBookingSearchResultColumnStructure,
    IBookingSearchResultConfig, IBookingSearchResultField, IBookingSearchResultRow,
} from "libraries/interfaces/IConfigurableTable";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { faAngleDown, faAngleUp, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Yii } from "libraries/interfaces/Yii";
import { MatListOption, MatSelectionList } from "@angular/material/list";
import { IApiPagingOutput } from "libraries/service/resources/IApiPagingOutput";
import { ILabels } from "libraries/interfaces/ILabels";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import {
    IValueType,
} from "libraries/pipes/configurable-table/compute-value.pipe";
import { ESashaPermissions } from 'libraries/enums/e-sasha-permissions';
import { ProcessingType } from "libraries/service/processing/processing.service";
import { BookingListDomainService } from "libraries/service/booking-list-domain/booking-list-domain.service";
import { ArrayHelperService } from "libraries/service/array-helper/array-helper.service";


export interface ICollapsedColumn {
    bookingIndex: number;
    collapserRef: string;
}

const NB_COL: number = 24;

@Component({
    selector: 'configurable-table',
    template: `
        <mat-selection-list class="list" #selectionListBookings
                            [(ngModel)]="selectedOptions"
                            (selectionChange)="getBookingSelection()">

            <header class="header booking-list-header">
                <mat-checkbox *ngIf="bookingForTable?.length && selectable"
                              [disabled]="bookingForTable?.length !== bookings?.length"
                              [checked]="selectedOptions.length === bookingForTable.length"
                              class="btn actionHeaderLink e2e-select-all-booking"
                              (change)="onChangeSelect($event)">
                    <span class="space-left">{{ getSelectionRange() }}</span>
                </mat-checkbox>

                <mat-slide-toggle class="btn actionDo sep-left"
                                  *ngIf="selectable && canFilter && selectedOptions.length > 0"
                                  [(ngModel)]="filterThisSelection">
                    {{ labels.selectionFilter }}
                </mat-slide-toggle>

                <ng-container *permissionIf="exportPermission">
                    <btn *ngIf="selectable && canExportExcel && selectedOptions.length > 0"
                         class="btn-csv"
                         [label]="labels.exportExcel" type="actionDo" (click)="action('csvExport')"></btn>
                </ng-container>
                <ng-content select=".list-header"></ng-content>
            </header>

            <ng-content select=".list-body"></ng-content>
            <table mat-table
                   #myTable
                   [dataSource]="bookingForTable"
                   multiTemplateDataRows
                   [trackBy]="getBookingId"
                   *ngIf="bookingForTable">
                <ng-container *ngFor="let row of config.rowArray; let rowIndex = index;">
                    <ng-container
                            *ngFor="let column of columnArrayToDisplay[rowIndex]; let columnIndex = index; let lastColumn = last;">
                        <ng-container [matColumnDef]="column">
                            <th-text *matHeaderCellDef [isLeft]="true" [width]="colWidth"
                                     [isHidden]="true"></th-text>
                            <ng-container *matCellDef="let element; let bookingIndex = dataIndex;">
                                <ng-container>
                                    <td-text
                                            *ngIf="(element | canCreateTdFullCondition:columnIndex:rowIndex:bookingIndex:
                                            lastColumn:columnArrayToDisplay:config:pathByElementKey:row:column:collapsedRow)"
                                            [isLightColor]="bookingIndex % 2 === 0"
                                            [colspan]="rowIndex | colspan:column:config:columnIndex"
                                            [isTop]="true"
                                            [noBorder]="true"
                                            [isHidden]="!(filterThisSelection ? (selectedOptions | isSelectedBooking:element.code) : true)"
                                            [class.first-item-row]="rowIndex === 0">
                                        <div *ngIf="row.collapserId && (column | isSpecificCell:'cC_')"
                                             class="collapser">
                                            <btn [type]="btnTypes.actionLink"
                                                 *ngIf="collapserPermission"
                                                 (onClick)="toggleRowVisibility(bookingIndex, row.collapserId)">
                                                <fa-icon
                                                        [icon]="(bookingIndex | isVisibleRow:row.collapserId:collapsedRow ) ? iconAngleUp:  iconAngleDown"
                                                        class="icon"></fa-icon>
                                            </btn>
                                        </div>
                                        <ng-container *ngIf="(column | isSpecificCell:'sC_') && rowIndex === 0">
                                            <mat-list-option #listOptionBooking
                                                             (mouseenter)="listOptionBooking.focus()"
                                                             class="list-row"
                                                             [ngClass]="{'isSelected': listOptionBooking.selected}"
                                                             [value]="element"
                                                             [disabled]="!selectable"
                                                             [checkboxPosition]="'before'">
                                            </mat-list-option>
                                        </ng-container>
                                        <ng-container
                                                *ngIf="!((column | findColumnByKey:config) | isGroupArray ) && (column | findColumnByKey:config)">
                                            <ng-container>
                                                <div *ngFor="let key of (column | findColumnByKey:config).fieldKeyArray">
                                                    <configurable-td-content [element]="element"
                                                                             [fieldKey]="key"
                                                                             [path]="pathByElementKey[key]"
                                                    ></configurable-td-content>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container
                                                *ngIf="((column | findColumnByKey:config) | isGroupArray) && !row.collapserRef && !row.collapserId">
                                            <div *ngFor="let group of (column | findColumnByKey:config).groupArray"
                                                 class="group">
                                                <div *ngIf="bookingIndex | isVisibleColumn:group.collapserRef: collapsedColumn"
                                                     class="group-content">
                                                    <configurable-td-content
                                                            *ngFor="let key of group.fieldKeyArray; let l = last"
                                                            [element]="element"
                                                            [fieldKey]="key"
                                                            [separator]="group.separator"
                                                            [isLastItemOfGroup]="l"
                                                            [path]="pathByElementKey[key]"
                                                    ></configurable-td-content>
                                                </div>
                                                <div *ngIf="group.collapserId" class="collapser">
                                                    <btn [type]="btnTypes.actionLink"
                                                         (onClick)="toggleColumnVisibility(bookingIndex, group.collapserId)">
                                                        <fa-icon
                                                                [icon]="(bookingIndex | isVisibleColumn:group.collapserId:collapsedColumn ) ? iconAngleUp:  iconAngleDown"
                                                                class="icon"></fa-icon>
                                                    </btn>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </td-text>

                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container>
                    <tr mat-header-row
                        *matHeaderRowDef="columnArrayToDisplay[0]"
                        [class.hidden-header]="config.isVisibleHeader"></tr>
                </ng-container>
                <ng-container *ngFor="let tableRow of config.rowArray; let tableRowIndex = index;">
                    <tr mat-row
                        *matRowDef="let row; columns: columnArrayToDisplay[tableRowIndex];"></tr>
                </ng-container>
            </table>
        </mat-selection-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./configurable-table.component.scss'],
})


export class ConfigurableTableComponent implements OnInit, OnChanges {
    //mat-table Inputs
    @Input()
    public config: IBookingSearchResultConfig;

    @Input()
    public bookings: IGetBookingsCommonResponse[];
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    //mat-list Inputs
    @Input()
    public selectable: boolean = true;

    @Input()
    public canFilter: boolean = true;

    @Input()
    public canExportExcel: boolean = true;

    @Input()
    public recordset: IApiPagingOutput;

    @Input()
    public selectedOptions: IGetBookingsCommonResponse[] = [];

    @Output()
    public readonly onSelect: EventEmitter<IGetBookingsCommonResponse[]> = new EventEmitter();

    @Output()
    public readonly onAction: EventEmitter<string> = new EventEmitter();

    @ViewChild('selectionListBookings')
    public selectionListBookings: MatSelectionList;

    @ViewChildren('listOptionBooking')
    public listOptionBooking: MatListOption;

    //mat-table
    public bookingForTable: IGetBookingsCommonResponse[];
    public columnArrayToDisplay: string[][] = [];
    public colWidth: string = 100 / NB_COL + '%';
    public btnTypes: typeof BtnStyleTypes = BtnStyleTypes;
    public iconAngleDown: IconDefinition = faAngleDown;
    public iconAngleUp: IconDefinition = faAngleUp;
    public collapsedColumn: Array<ICollapsedColumn> = [];
    public collapsedRow: Array<ICollapsedColumn> = [];
    public pathByElementKey: { [key: string]: string } = {};
    public bookingSearchConfig: IBookingSearchResultConfig;
    public configurableTdContent: IValueType;
    public collapserPermission: boolean = false;

    //mat-list
    public readonly exportPermission: string = "sasha.bookingExport.use";
    public filterThisSelection: boolean = false;
    public processingType: ProcessingType;
    public labels: ILabels = {
        selectAll: Yii.t('wui-sasha-js', 'Sélectionner les résultats'),
        selectionFilter: Yii.t('wui-sasha-js', 'Filtrer sur la selection'),
        exportExcel: Yii.t('wui-sasha-js', 'Export Excel'),
    };

    constructor(
        private readonly permissionService: PermissionResourceService,
        private readonly bookingListDomainService: BookingListDomainService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly arrayHelperService: ArrayHelperService,
    ) {
    }

    public ngOnInit(): void {
        this.permissionService.getPermissionsStartingWith(['sasha'])
            .subscribe((permissions: Set<string>): void => {
                this.collapserPermission = permissions.has('sasha.booking.air.fare.optimisation.use') ||
                    permissions.has('sasha.qualityCheck.show');
            });
        let columnArrayToDisplay: string[][] = [[]];
        this.config.rowArray.forEach((row: IBookingSearchResultRow, rowIndex: number) => {
            columnArrayToDisplay[rowIndex] = row.columnStructureArray
                .map((column: IBookingSearchResultColumnStructure): string => column.key);

            const missingColumsQuantity: number = 24 - columnArrayToDisplay[rowIndex].length;
            for (let i = 0; i < missingColumsQuantity; i++) {
                //cC : fakeCell_
                columnArrayToDisplay[rowIndex].push(`fC_${rowIndex}${i}`);
            }
        });
        if (this.config.rowArray.find((row: IBookingSearchResultRow): boolean => Boolean(row.collapserId))) {
            columnArrayToDisplay = columnArrayToDisplay.map((columnArray: string[], i: number): string[] => {
                //cC : collapserCell_
                return [...columnArray, `cC_${i}`];
            });
        }
        if (this.config.canSelectItems) {
            columnArrayToDisplay = columnArrayToDisplay.map((columnArray: string[], i: number): string[] => {
                //cC : selectableCell_
                return [`sC_${i}`, ...columnArray];
            });
        }
        this.columnArrayToDisplay = columnArrayToDisplay;
        this.initPathByElementKey();
        this.getConfigurableTableConfig();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.bookings?.currentValue) {
            // this.bookingForTable = this.bookings;
            const chunks: IGetBookingsCommonResponse[][] = this.arrayHelperService.chunkArray(this.bookings, 2);
            chunks.forEach((chunk: IGetBookingsCommonResponse[]): void => {
                setTimeout(() => {
                    this.bookingForTable = [...(this.bookingForTable || []), ...chunk];
                    this.changeDetectorRef.detectChanges();
                },);
            });
        }
    }


    //Mat-List functions
    public onChangeSelect(event: MatCheckboxChange): void {
        event.checked ?
            this.selectionListBookings.selectAll() :
            this.selectionListBookings.deselectAll();
        this.getBookingSelection();
    }

    public getBookingId(index: number, booking: IGetBookingsCommonResponse): string {
        return booking.code;
    }

    public getBookingSelection(): void {
        this.onSelect.emit(this.selectedOptions);
    }

    public action(treatmentName: string): void {
        this.onAction.emit(treatmentName);
    }

    public getSelectionRange(): string {
        const selectAll: string = this.labels.selectAll;
        const to: string = Yii.t('wui-sasha-js', 'à');

        if (this.recordset) {
            const first: number = this.recordset.first;
            const total: number = this.recordset.total;
            const last: number = Math.max(0, Math.min(total, this.recordset.first + this.recordset.nbrecord - 1));
            return `${selectAll} ${first} ${to} ${last} / ${total}`;
        } else {
            return `${selectAll} 1 ${to} ${this.bookings.length} / ${this.bookings.length}`;
        }
    }

    public focus(): void {
        this.selectionListBookings.focus();
    }

    private getConfigurableTableConfig(): void {
        this.bookingListDomainService.getTableConfiguration().subscribe((config: IBookingSearchResultConfig): void => {
            this.bookingSearchConfig = config;
        });
    }

    public toggleColumnVisibility(bookingIndex: number, collapserId: string): void {
        const related: number = this.collapsedColumn.findIndex((item: ICollapsedColumn): boolean => item.bookingIndex === bookingIndex && item.collapserRef === collapserId);
        if (related < 0) {
            this.collapsedColumn = [...this.collapsedColumn, {bookingIndex, collapserRef: collapserId}];
        } else {
            this.collapsedColumn.splice(related, 1);
            this.collapsedColumn = [...this.collapsedColumn];
        }
    }

    //Mat-table functions
    public toggleRowVisibility(bookingIndex: number, collapserId: string): void {
        const related: number = this.collapsedRow.findIndex((item: ICollapsedColumn): boolean => item.bookingIndex === bookingIndex && item.collapserRef === collapserId);
        if (related < 0) {
            this.collapsedRow = [...this.collapsedRow, {bookingIndex, collapserRef: collapserId}];
        } else {
            this.collapsedRow.splice(related, 1);
            this.collapsedRow = [...this.collapsedRow];
        }
    }

    private initPathByElementKey(): void {
        this.config.fieldArray.forEach((field: IBookingSearchResultField): void => {
            this.pathByElementKey[field.key] = field.elasticSearchPath;
        });
    }
}
